import { render, staticRenderFns } from "./editPlan.vue?vue&type=template&id=203c910c&scoped=true&"
import script from "./editPlan.vue?vue&type=script&lang=js&"
export * from "./editPlan.vue?vue&type=script&lang=js&"
import style0 from "./editPlan.vue?vue&type=style&index=0&id=203c910c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203c910c",
  null
  
)

export default component.exports